import React from 'react';
import Radio from '@mui/material/Radio';
import CommonTypography from '@src/new-components/Typography';
import Badge from './Badge';
import { StyledRadioField } from './index.style';

// `options`: [{ value, label, badge }]. Badge để ghi chú trạng thái tính năng.
const RadioField = ({ name, options, value, onChange }) => (
  <StyledRadioField>
    {options.map(({ value: optionValue, label, badge }) => {
      const id = `${name}-${optionValue}`;
      return (
        <div className="radio-option" key={optionValue}>
          <Radio
            id={id}
            name={name}
            size="small"
            checked={value === optionValue}
            onChange={() => onChange(optionValue)}
          />
          {/* Nối bằng htmlFor để bấm vào chữ cũng chọn được. */}
          <label className="radio-option-label" htmlFor={id}>
            <CommonTypography className="radio-label" variant="body-14-regular">
              {label}
            </CommonTypography>
            {badge && <Badge>{badge}</Badge>}
          </label>
        </div>
      );
    })}
  </StyledRadioField>
);

export default RadioField;
